import { useEffect, useRef, useState } from "react";

export default function Toast({ message, actionLabel, onAction, onClose }) {
  const [exiting, setExiting] = useState(false);
  const timerRef = useRef(null);
  const exitRef = useRef(null);

  useEffect(() => {
    if (!message) return;
    setExiting(false);
    clearTimeout(timerRef.current);
    clearTimeout(exitRef.current);

    // Start exit animation at 5.4s, fully gone at 6s
    timerRef.current = setTimeout(() => {
      setExiting(true);
      exitRef.current = setTimeout(() => onClose?.(), 600);
    }, 5400);

    return () => {
      clearTimeout(timerRef.current);
      clearTimeout(exitRef.current);
    };
  }, [message, onClose]);

  if (!message) return null;

  const dismiss = () => {
    clearTimeout(timerRef.current);
    clearTimeout(exitRef.current);
    setExiting(true);
    exitRef.current = setTimeout(() => onClose?.(), 600);
  };

  return (
    <div className={`toast${exiting ? " toast-exit" : ""}`} role="status" aria-live="polite">
      <span>{message}</span>
      {actionLabel ? (
        <button type="button" className="toast-action" onClick={() => { onAction?.(); dismiss(); }}>
          {actionLabel}
        </button>
      ) : null}
      <button type="button" className="toast-close" onClick={dismiss} aria-label="Dismiss notification">
        ✕
      </button>
    </div>
  );
}
